import { WrapperFormGroupModuleImporter } from 'wrapper-form-group';
import { CkeditorWidgetOption } from 'widget-ckeditor';

export class BaseCkeditorWidgetOption<
  Value extends string,
  Parent = null,
> extends CkeditorWidgetOption<Value, Parent> {
  constructor(options?: Partial<BaseCkeditorWidgetOption<Value, Parent>>) {
    super({
      type: 'string',
      widget: 'ckeditor',
      wordStatistics: false,
      removePlugins: ['Title'],
      ...options,
    });
    if (!Array.isArray(this.wrappers)) {
      this.wrappers = [];
    }
    this.wrappers.push(new WrapperFormGroupModuleImporter());
  }
}
